//请自行添加语言资源
const onSiteEfficiency = {
  plantName:'基地名称',
  appointmentNo:'预约单',
  vehicleNo:"车牌号",
  skuNo:"货品ID(物料编码)",
  skuName:'货品名称',
  appointmentWeight:'预约重量',
  vehicleAssignStorageCode:'库位编码',
  vehicleAssignStorageName:'库位名称',
  supplierCode:'供应商编码',
  supplierName:'供应商名称',
  appointmentDate:'预约日期',

  appointmentTime:'预约时间',
  vehicleSignTime:"签到时间",
  vehicleQueueTime:"排队时间",
  queueJumpingReason:"手工插队原因",
  toxinSampleTimeBegin:'毒素开始抽检时间',
  selfSaleOptTime:'认卖时间',
  toxinSampleResultTime:'毒素结果时间',
  vehicleRequestLockedTime:'叫号时间',
  vehicleInPlantTime:'入厂时间',
  qcSampleBeginTime:'质检取样时间',
  unpeelWeighEndTime:'重车过磅时间',

  qcResultTime:'质检出结果时间',
  startUnloadTime:"开始卸车时间",
  qcSecondaryTime:"二检发起时间",
  qcSecondaryConfirmTime:'二检确认时间',
  qcSecondaryStartTime:'二检开始检测时间',
  endUnloadTime:'结束卸车时间',
  peelWeighEndTime:'轻车过磅时间',
  vehicleOutPlantTime:'出厂时间',
  inPlantMinite:'在厂时间',
  custodian:'保管',
  storageBatchNo:'卸车批次',
  msg:{
    vehicleNo: '请输入车牌号'
  }
};
export default onSiteEfficiency



// WEBPACK FOOTER //
// ./src/page/report/onSiteEfficiency/lang/onSiteEfficiency.en.js